<table class="table" ng-show="ocorrencias.length">
  <thead>
    <tr>
      <th>Tipo</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody ng-repeat="ocorrencia in ocorrencias track by $index">
    <!-- TODO: alterar forma de adicionar a classe de linha ativa para considerar o $index e não o isOpen, visto que não o angular não observa alterações nele -->
    <tr ng-repeat="item in ocorrencia.items"
        ng-mouseleave="resetAnimationMarker(ocorrencia.marker.marker, $parent.$index)"
        ng-mouseover="setAnimationMarker(ocorrencia.marker.marker, $parent.$index)"
        ng-click="openInfoWindow(ocorrencia.marker.marker, $parent.$index)"
        ng-class="{'activate-line': ocorrencia.marker.leafletMarker.isPopupOpen()}"
        class="pointer">
      <td class="vertical-middle">{{item.descricao | humanize}}</td>
      <td>
        <span agro-label-historico historico="{situacao: item.status.descricaoJson, tipo_to_pt_br: item.status.descricao}">
        </span>
      </td>
    </tr>
  </tbody>
</table>

<table class="table" ng-show="outrasOcorrencias.length">
  <thead>
    <tr>
      <th>Descrição</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="ocorrencia in outrasOcorrencias track by $index"
      ng-mouseleave="resetAnimationMarker(ocorrencia.marker.marker, $index)"
      ng-mouseover="setAnimationMarker(ocorrencia.marker.marker, $index)"
      ng-click="openInfoWindow(ocorrencia.marker.marker, $index)"
      ng-class="{'activate-line': ocorrencia.marker.leafletMarker.isPopupOpen()}"
      class="pointer">
      <td>{{ocorrencia.descricao}}</td>
    </tr>
  </tbody>
</table>
